import { esgCoverageToTableParser } from 'shared/parsers/esgCoverageToTable/esgCoverageToTableParser';
import { GET_ESG_COVERAGE_DATA_SUCCESS, GET_ESG_COVERAGE_DATA_ERROR } from './esgCoverageActions';

const initialState = {
  total: 0,
  isPending: true,
  error: undefined,
  data: [],
};

export function esgCoverage(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_ESG_COVERAGE_DATA_SUCCESS:
      return {
        ...state,
        total: payload.count,
        data: esgCoverageToTableParser(payload.results),
        error: undefined,
        isPending: false,
      };
    case GET_ESG_COVERAGE_DATA_ERROR:
      return {
        ...state,
        total: 0,
        data: [],
        error: payload,
        isPending: false,
      };
    default:
      return state;
  }
}
